import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import shopService from 'services/shop';

const initialState = {
  loading: false,
  myShop: {},
  isEnabledStatusChange: false,
  error: '',
};

/**
 * Fetches the single app shop via admin shops/paginate (single-vendor).
 */
export const fetchMyShop = createAsyncThunk(
  'shop/fetchMyShop',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await shopService.getAll({
        perPage: 1,
        status: 'approved',
        ...params,
      });
      const list = Array.isArray(data) ? data : data?.data ?? [];
      const shop = list[0] ?? {};
      return { data: shop };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message);
    }
  },
);

const myShopSlice = createSlice({
  name: 'myShop',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMyShop.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMyShop.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.myShop = payload.data ?? {};
      state.isEnabledStatusChange = payload.data?.delivery_type === 2;
      state.error = '';
    });
    builder.addCase(fetchMyShop.rejected, (state, action) => {
      state.loading = false;
      state.myShop = {};
      state.error = action.payload?.message || action.error?.message || '';
    });
  },
});

export default myShopSlice.reducer;
